<template>
  <Transition
    enter-active-class="duration-sheet ease-pj"
    enter-from-class="translate-y-4 opacity-0 motion-reduce:translate-y-0"
    leave-active-class="duration-exit ease-pj"
    leave-to-class="translate-y-4 opacity-0 motion-reduce:translate-y-0"
  >
    <div
      v-if="props.open"
      class="pointer-events-none fixed inset-x-3 bottom-dock z-bar flex items-stretch justify-center gap-2.5"
    >
      <slot />
    </div>
  </Transition>
</template>

<script lang="ts" setup>
/**
 * The one floating row at the foot of a venue page — the order, and the way
 * to book ahead, side by side.
 *
 * Owns the position and the mount/leave animation so its children don't have
 * to: `PjCartBar` and the reserve control each just render a pill and trust
 * this to place it. Takes an `open` prop rather than being wrapped in the
 * caller's own `v-if`, matching `PjScanSheet`/`PjAccountSheet` — a slot with
 * nothing truthy inside it still counts as slot content at compile time, so
 * checking for that here instead would never actually hide anything.
 */
const props = defineProps<{ open?: boolean }>()
</script>
